import { DEFAULT_VISIT_PATH } from "../../config/constants";

const buildVisitPath = (baseVisitPath, queryParams) => {
	const searchParams = new URLSearchParams();

	queryParams.forEach((param) => {
		searchParams.set(param.name, param.value);
	});

	return `${baseVisitPath}?${searchParams}`;
};

export const generateCompanyVisitPath = ({
	isTargeted,
	visitLinkQueryString,
	filter,
	companySlug,
	rank,
}) => {
	const visitPathParam = filter === "demo" ? "demo" : DEFAULT_VISIT_PATH;
	const baseVisitPath = buildVisitPath(`/${visitPathParam}/${companySlug}`, [
		{ name: "isTargeted", value: isTargeted ? "1" : "0" },
		{ name: "rank", value: rank.toString() },
	]);

	return `${baseVisitPath}${visitLinkQueryString}`;
};
